import { ShieldAlert } from 'lucide-react';
import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { PageChrome } from '@/components/layout/page-chrome';
import type { Crumb } from '@/components/layout/page-chrome-context';
import { StatePanel } from '@/components/ui/StatePanel';
import type { PermissionState } from '@/hooks/usePermission';

// Chrome de una pantalla con permiso (G4, cierre F1, nota de QA FUN-06). Mientras el
// permiso no está confirmado (cargando, error o denegado), las migas y el encabezado no
// nombran la pantalla: quien no tiene acceso no debe enterarse de qué hay en esa URL.

const NEUTRAL: Crumb[] = [{ label: 'QMS', to: '/dashboard', strong: true }];

export function GatedChrome({
  state,
  breadcrumb,
  navContext,
}: {
  state: PermissionState;
  breadcrumb: Crumb[];
  navContext: string;
}): ReactElement {
  return state === 'granted' ? (
    <PageChrome breadcrumb={breadcrumb} navContext={navContext} />
  ) : (
    <PageChrome breadcrumb={NEUTRAL} />
  );
}

/** Aviso de acceso restringido, sin nombrar la pantalla, con salida al Panel. */
export function RestrictedPanel(): ReactElement {
  return (
    <StatePanel icon={<ShieldAlert />} title="No tienes acceso a esta sección" role="alert">
      Tu rol no incluye esta sección. Si la necesitas, solicita el permiso al administrador de
      calidad. <Link to="/dashboard">Ir al Panel</Link>
    </StatePanel>
  );
}
